import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface unBlockUserResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}
export function unblockUserAction(userId: string): Promise<ApiResponse<unBlockUserResponse>> {
  return api.patch<ApiResponse<unBlockUserResponse>>(`/users/${userId}/unblock`)
}
